<!-- TNK session.clearData(); -->
<a class="mx-2 p-2 font-normal text-1.25 hover:text-white hover:no-underline" routerLink="/user/assignments" routerLinkActive="ngActiveLinkWhite" ariaCurrentWhenActive="page" (click)="session.resetCampaignData()">Assignments</a>

<!-- TNK ac.newCampaign(); -->
<!-- @if (authService.isMaster() || authService.isMarshal()) {
  <a class="mx-2 p-2 font-normal text-1.25 hover:text-white hover:no-underline" routerLink="/campaign/0/edit" routerLinkActive="ngActiveLinkWhite" (click)="session.closeMobileMenus($event)">New Campaign</a>
} -->

<!-- @if (authService.isMaster()) { -->
<!-- <a class="mx-2 p-2 font-normal text-1.25 hover:text-white hover:no-underline" (click)="session.testingOnClick()">Testing</a> -->
<!-- Testing Dropdown Menu -->
<!-- Reminder: Both desktop & mobile share the SAME menu -->
<!-- @if (session.menuTestingVisible) {
    <div id="_testing-menu_" class="z-40 p-4 left-[34rem] absolute flex flex-col shadow-xl mt-[3rem] text-left navbarLeft8 rounded-b-md">
      <menu-items-testing class="w-full flex flex-col"></menu-items-testing>
    </div>
  } -->
<!-- } -->
